// extracted by mini-css-extract-plugin
module.exports = {"main":"Component3_main__1fevz","line":"Component3_line__B7E07","title":"Component3_title__3_Xpw","value":"Component3_value__2_mLT"};